export const MOBEAT_STAFF_ROLE = 'mobeat_staff';

export function isMobeatStaff(organizationRole) {
  return organizationRole === MOBEAT_STAFF_ROLE;
}
